// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"DataTable_btnContainer__3o-Vf","viewBtn":"DataTable_viewBtn__2lw9z"};